var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlistHeaderhover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=heart, Property 2=ON",
    clipPath: "url(#clip0_828_1436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_828_1436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0497 5.76185C25.4112 5.12311 24.6532 4.61641 23.8189 4.27071C22.9845 3.925 22.0903 3.74707 21.1872 3.74707C20.284 3.74707 19.3898 3.925 18.5555 4.27071C17.7211 4.61641 16.9631 5.12311 16.3247 5.76185L14.9997 7.08685L13.6747 5.76185C12.385 4.47224 10.636 3.74774 8.81216 3.74774C6.98837 3.74774 5.23928 4.47224 3.94966 5.76185C2.66005 7.05147 1.93555 8.80056 1.93555 10.6244C1.93555 12.4481 2.66005 14.1972 3.94966 15.4869L5.27466 16.8119L14.9997 26.5369L24.7247 16.8119L26.0497 15.4869C26.6884 14.8484 27.1951 14.0904 27.5408 13.256C27.8865 12.4217 28.0644 11.5275 28.0644 10.6244C28.0644 9.72124 27.8865 8.82698 27.5408 7.99266C27.1951 7.15833 26.6884 6.4003 26.0497 5.76185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0497 5.76185C25.4112 5.12311 24.6532 4.61641 23.8189 4.27071C22.9845 3.925 22.0903 3.74707 21.1872 3.74707C20.284 3.74707 19.3898 3.925 18.5555 4.27071C17.7211 4.61641 16.9631 5.12311 16.3247 5.76185L14.9997 7.08685L13.6747 5.76185C12.385 4.47224 10.636 3.74774 8.81216 3.74774C6.98837 3.74774 5.23928 4.47224 3.94966 5.76185C2.66005 7.05147 1.93555 8.80056 1.93555 10.6244C1.93555 12.4481 2.66005 14.1972 3.94966 15.4869L5.27466 16.8119L14.9997 26.5369L24.7247 16.8119L26.0497 15.4869C26.6884 14.8484 27.1951 14.0904 27.5408 13.256C27.8865 12.4217 28.0644 11.5275 28.0644 10.6244C28.0644 9.72124 27.8865 8.82698 27.5408 7.99266C27.1951 7.15833 26.6884 6.4003 26.0497 5.76185Z",
    stroke: "#EC187B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_828_1436",
    x: -1.56445,
    y: 0.24707,
    width: 33.1289,
    height: 29.9969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.0941176 0 0 0 0 0.482353 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_828_1436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_828_1436",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_828_1436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistHeaderhover);
export default __webpack_public_path__ + "static/media/wishlistHeaderhover.bf72f83b7b183271b3915025293d951e.svg";
export { ForwardRef as ReactComponent };